<div class="v4-layout-info">
  <div class="v4-layout-info-title flex flex-row items-center justify-between">
    <span>{{ "word.remarks" | translate }}</span>
    <div class="operator">
      <ng-container *ngIf="mode === 'view'">
        <a nz-button nzType="link" nzSize="small" (click)="mode = 'edit'">
          {{ (note ? "word.modify" : "word.add_remark") | translate }}
        </a>
      </ng-container>

      <ng-container *ngIf="mode === 'edit'">
        <a nz-button nzType="link" nzSize="small" (click)="onCancel()">{{ "word.cancel" | translate }}</a>
        <a class="ml-2" nz-button nzType="link" nzSize="small" (click)="onConfirm()">{{ "word.save" | translate }}</a>
      </ng-container>
    </div>
  </div>

  <div
    class="v4-layout-field"
    [class.align-items-start]="mode === 'edit'"
    [formGroup]="form"
    *ngIf="note || mode === 'edit'"
  >
    <div class="v4-layout-field-label">{{ "order.remarks_content" | translate }}</div>
    <div class="v4-layout-field-control">
      <div class="v4-layout-field-row">
        <span *ngIf="note && mode === 'view'" [innerHTML]="note?.replaceAll('\n', '<br>')"></span>
        <textarea
          *ngIf="mode === 'edit'"
          formControlName="note"
          [placeholder]="'placeholder.order_remarks' | translate"
          nz-input
          rows="3"
        ></textarea>
      </div>
    </div>
  </div>
</div>
